// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function captchaValidator({ spec, prsSupport, userInputName, userInputValue, userInputValues }: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName !== 'captchaToken') {
    return;
  }

  return onlyWhen('field_captcha_token') && validateCaptchaToken(userInputValue);
}

function validateCaptchaToken(captchaToken: string): ?UserInputValidationError {
  if(!captchaToken) {
    return { id: 'invalid' };
  }
}
